<p-toast position="top-right"></p-toast>
<p-card>
  <div class="pdfViewer mt-7 ml-8 mr-8">
    <div class="mb-7">
      <div class="font-bold text-4xl text-900 mb-3"[hidden]="title1Hidden">{{'acceptation_cgu.title' | translate}}</div>
      <div class="font-bold text-4xl text-900 mb-3"[hidden]="title2Hidden">{{'acceptation_cgu.newtitle' | translate}}</div>
    </div>
    <div class="col-lg-12">
    </div>
    <div class="col-lg-12" style="height: 680px;">
      <ngx-extended-pdf-viewer [src]="fileURL" (pageChange)="onPageChange($event)" [useBrowserLocale]="true"
                               [scrollMode]="0"
                               (pagesLoaded)="onPdfLoadComplete($event)" [zoom]="zoom"  [textLayer]="true">
      </ngx-extended-pdf-viewer>
    </div>

    <div class="field mt-4 col-12">
      <div *ngIf="showAcceptationCguRegle1">
        <label>
          <input type="checkbox" id="regle1" (change)="onCheckboxRegle1($event)" [disabled]="disabledCheckBox" />
          <b>{{'acceptation_cgu.formulaire.regle_1' | translate}}</b>
        </label>
      </div>
      <div class="field mt-4" *ngIf="showAcceptationCguRegle2">
        <label>
          <input id="regle2" type="checkbox" (change)="onCheckboxRegle2($event)" [disabled]="disabledCheckBox" />
          <b>{{'acceptation_cgu.formulaire.regle_2' | translate}}</b>
        </label>
      </div>
    </div>
    <div class="field mb-4 col-12">

      <div class="buttons">
        <button class="flex-auto p-button- mr-4" *ngIf="!showSpinner" pButton pRipple type="button" icon="pi pi-check"
                (click)="downloadDocument()" label="{{'acceptation_cgu.formulaire.buttons.telecharger' | translate}}">
        </button>
        <button id="refuser" class="flex-auto p-button mr-4" *ngIf="!showSpinner" pButton pRipple type="button"
                icon="pi pi-times" (click)="refuser()"
                label="{{'acceptation_cgu.formulaire.buttons.refuser' | translate}}">
        </button>

        <button id="accepter" class="flex-auto p-button mr-4" *ngIf="!showSpinner" pButton pRipple type="button"
                icon="pi pi-check" (click)="accepter()" [disabled]="toggleBool"
                label="{{'acceptation_cgu.formulaire.buttons.accepter'| translate}}">
        </button>

      </div>
    </div>
  </div>
</p-card>
